import React from "react";

function CustomData(props) {
  return (
    <>
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-10 mx-auto">
          <div className="my-5">
        <h1 className="tab-center">{props.section}</h1>
        <span className="text-align-center">{props.para}</span>
      </div>
            <div className="row">
              <div className="col-md-10 w-100 col-lg-12 card-col d-flex justify-content-center flex-wrap">
                {/* using map on props.data from Service  */}

                {props.data.map((item) => {
                  return (
                    <div className="card col-lg-3 col-md-5 col-sm-5 col-mx-auto text-align-center">
                      <div className="card-body">
                        <h5 className="card-title">{item.title}</h5>
                        <p className="card-text">{item.disc}</p>
                        {item.link && (
                          <a
                            href={item.link}
                            target="_blank"
                            className="projectLink"
                          >
                            {item.img && (
                              <img
                                src={item.img}
                                className="card-img-top project_image"
                                alt="..."
                              />
                            )}
                            <button className="btn-gs">project..</button>
                          </a>
                        )}
                        {!item.link && (
                          <a
                            href={item.link}
                            target="_blank"
                            className="projectLink"
                          >
                            {item.img && (
                              <img
                                src={item.img}
                                className="card-img-top project_image"
                                alt="..."
                              />
                            )}
                            {item.link && (
                              <button className="btn-gs">project..</button>
                            )}
                          </a>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomData;
